import React from 'react';
import PropTypes from 'prop-types';
import Api, { Utils } from '../../Api';
import { formatPrice } from './tools';

import Pencil from '../../images/icons/pencil.svg';
import PencilHover from '../../images/icons/pencil-hover.svg';

import CloseButton from '../../images/icons/close-button.svg';

export default class BagItem extends React.Component {
  static propTypes = {
    itemList: PropTypes.array.isRequired,
    product: PropTypes.object.isRequired,
    disableEditing: PropTypes.bool
  };

  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    Utils.bindThis(this, [
      'editProductClick',
      'removeFromCart',
      'productImages'
    ]);
  }

  productImages() {
    let imageList = [];
    this.props.product.images.forEach(image => {
      imageList.push(image);
    });

    this.props.product.options.forEach(productOption => {
      productOption.images.forEach(image => {
        imageList.push(image);
      });
    });

    return imageList;
  }

  editProductClick(event) {
    if (event.defaultPrevented) return;
    if (this.props.disableEditing) return;
    event.preventDefault();

    let url = `/retailer/${this.props.retailerToken}/product/${this.props.product.token}`;
    this.context.router.push(url);
  }

  removeFromCart(event) {
    event.preventDefault();

    let items = this.props.itemList.map(item => {
      return item.product_option_token;
    });

    return Api.removeFromCart(items);
  }

  render() {
    let itemList = this.props.itemList;
    let product = this.props.product;
    let productOptions = [];
    product.options.forEach(option => {
      let currentItem = itemList.find(item => { return option.token === item.product_option_token; });
      if (!currentItem) return;

      productOptions.push({
        item: currentItem,
        option: option
      });
    });
    let productOptionsDisplay = productOptions.map(productOption => {
      if (productOption.option.name.toLowerCase() === 'default') return null;
      let optionName = productOption.option.name;
      if (!optionName && productOption.option.group_name.toLowerCase() === 'color') {
        optionName = productOption.option.color.name;
      }

      return <span key={productOption.option.token} className="cart-option-entry">{productOption.item.quantity} {optionName}</span>
    });

    let quantity = 0;
    let price = 0;
    itemList.forEach(item => {
      quantity += item.quantity;
      price += item.quantity * item.price_cents;
    });

    let imageUrl;
    let imageList = this.productImages();
    if (imageList.length > 0) {
      imageUrl = imageList[0].url;
    }

    let classNames = ['product-row'];
    if (!this.props.disableEditing) {
      classNames.push('link');
    } else {
      classNames.push('no-edit');
    }

    return (
      <div className={classNames.join(' ')} onClick={this.editProductClick}>
        <div className="quantity">
          <span className="value">{quantity}</span>
        </div>
        <div className="edit-icon">
          <span className="inactive"><img src={Pencil} role="presentation" /></span>
          <span className="active"><img src={PencilHover} role="presentation" /></span>
        </div>
        <div className="product-preview"><img src={imageUrl} role="presentation" /></div>
        <span className="product-info-block">
          <span className="product-name">{product.name}</span>
          <span className="product-options">{productOptionsDisplay}</span>
        </span>
        {formatPrice(price)}
        <span className="close-action" onClick={this.removeFromCart}><img src={CloseButton} role="presentation" /></span>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Cart/BagItem.js
 **/